import { z } from 'zod';

/**
 * テスト設計 対象 TestSet 選択画面の URL search スキーマ。
 *
 * - freeText:        テストセット名 / プロダクト名の部分一致検索
 * - page / pageSize: ページネーション
 */
export const testsetTargetsSearchSchema = z.object({
  page: z.coerce.number().min(1).optional().default(1),
  pageSize: z.coerce.number().min(1).optional().default(50),
  freeText: z.string().optional()
});
export type TestsetTargetsSearch = z.infer<typeof testsetTargetsSearchSchema>;